import service from '@/services/SICUDgpd_inf_fin';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, event) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_per_crd: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_per_crd: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                crd_dat_bie: event.step4.crd_dat_bie?.[0]?.lis_det_par || event.step4.crd_dat_bie,
                crd_dat_tras: event.step4.crd_dat_tras?.[0]?.lis_det_par
                  || event.step4.crd_dat_tras,
                crd_dat_mot: event.step4.crd_dat_mot?.[0]?.lis_det_par || event.step4.crd_dat_mot,
                cdr_dat_car: event.step4.cdr_dat_car?.[0]?.lis_det_par || event.step4.cdr_dat_car,
                crd_finan: event.step4.crd_finan?.[0]?.lis_det_par || event.step4.crd_finan,
                crd_moto: event.step4.crd_mot_pr?.[0]?.lis_det_par || event.step4.crd_mot_pr,
                crd_quis: event.step4.crd_quis?.[0]?.lis_det_par || event.step4.crd_quis,
              },
            ],
          },
        };

        let notification;

        service
          .post(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_per_crd;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_per_crd[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
